<form [formGroup]="form" (ngSubmit)="save()">
    <span class="float-end">
        <button type="submit" class="btn btn-primary d-print-none" [disabled]="!form.valid" i18n>Save</button>
        &nbsp;
        <div class="dropdown d-inline-block d-print-none">
            <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown"><fa-icon
                    [icon]="fa.faEllipsis"></fa-icon></button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li *ngIf="adsOrganization.id"><button type="button" class="dropdown-item" i18n></button></li>
            </ul>
        </div>
    </span>
    
    
    <h3><span i18n>Organization settings</span></h3>
    <span i18n>Created</span> {{ adsOrganization.created_at | date: 'short' }} &bull; <span i18n>Modified</span> {{ adsOrganization.updated_at
    | date: 'short' }} &bull; ID: {{ adsOrganization.id }}
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mt-4">
        <li [ngbNavItem]="'basics'">
            <button ngbNavLink i18n>Basics</button>
            <ng-template ngbNavContent>
                <div class="row g-3">
                    <div class="col-8">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="name" class="form-label" i18n>Legal name</label>
                                <input type="text" class="form-control" id="name" formControlName="name"
                                    [class.is-invalid]="form.get('name')?.invalid">
                            </div>
                            <div class="col-md-6">
                                <label for="company_id" class="form-label" i18n>Company ID</label>
                                <input type="text" class="form-control" id="company_id" formControlName="company_id"
                                    [class.is-invalid]="form.get('company_id')?.invalid">
                            </div>
                            <div class="col-md-6">
                                <label for="vat_id" class="form-label" i18n>VAT ID</label>
                                <input type="text" class="form-control" id="vat_id" formControlName="vat_id">
                            </div>
                            <div class="col-md-6">
                                <label for="street_address" class="form-label" i18n>Street address</label>
                                <input type="text" class="form-control" id="street_address" formControlName="street_address" 
                                    [class.is-invalid]="form.get('street_address')?.invalid">
                            </div>
                            <div class="col-md-6">
                                <label for="office" class="form-label" i18n>Office</label>
                                <input type="text" class="form-control" id="office" formControlName="office">
                            </div>
                            <div class="col-md-6">
                                <label for="postal_code" class="form-label" i18n>Postal code</label>
                                <input type="text" class="form-control" id="postal_code" formControlName="postal_code"
                                    [class.is-invalid]="form.get('postal_code')?.invalid">
                            </div>
                            <div class="col-md-6">
                                <label for="city" class="form-label" i18n>City</label>
                                <input type="text" class="form-control" id="city" formControlName="city"
                                    [class.is-invalid]="form.get('city')?.invalid">
                            </div>
                            <div class="col-md-6">
                                <label for="country" class="form-label" i18n>Country</label>
                                <select class="form-select" id="country" formControlName="country"
                                    [class.is-invalid]="form.get('country')?.invalid">
                                    <option [ngValue]="null" i18n>Select country</option>
                                    <option *ngFor="let country of countries | keyvalue | localeSort: 'value'" [value]="country.key">{{ country.value }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <h5 i18n>Display names</h5>
                                <hr class="m-0">
                            </div>
                            <div class="col-12">
                                <label for="display_name" class="form-label" i18n>English/default</label>
                                <input required
                                    [class.is-invalid]="form.get('display_name')?.invalid"
                                    type="text" class="form-control" id="display_name" formControlName="display_name">
                            </div>
                            <div *ngFor="let language of environment.supported_languages" class="col-md-6">
                                <label [for]="'display_name_' + language" class="form-label">{{ language | i18nSelect: languages }}</label>
                                <input [id]="'display_name_' + language" [formControlName]="'display_name_' + language" type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="notes" class="form-label d-block" i18n>Logo</label>
                                <img [src]="adsOrganization.picture" class="img-fluid rounded">
                                <input type="file" class="form-control mt-3" id="logo" (change)="logoChange($event)">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="my-3"></div>
</form>